/**
 * Mapping von Produkttyp-ID (Backend) auf den formsKey (Route-Parameter im Create-Wizard).
 * Wird in Step1.vue (Typauswahl) und Row.vue (Duplizieren) verwendet.
 */
export const PRODUCT_TYPE_ID_TO_FORMS_KEY = {
    1:  'plakate',
    2:  'flyer-faltblaetter',
    3:  'fotosatz-lose-blattsammlung',
    4:  'broschuren-pressehefte-kataloge',
    5:  'gutscheine-karten',
    6:  'cd-dvd',
    7:  'beileger-booklets',
    8:  'banner',
    10: 'aufsteller-displays/standee',
    11: 'aufsteller-displays/deckenhaenger',
    12: 'aufsteller-displays/saeule',
    13: 'aufsteller-displays/verkaufsdisplay',
    14: 'aufsteller-displays/roll-up-display',
    16: 'geschaeftsausstattung/bloecke',
    17: 'geschaeftsausstattung/briefboegen',
    18: 'geschaeftsausstattung/briefhuellen-umschlaege',
    19: 'geschaeftsausstattung/visitenkarten',
    20: 'geschaeftsausstattung/praesentationsmappen',
    22: 'aufkleber-etiketten/etiketten-auf-rolle',
    23: 'aufkleber-etiketten/etiketten-auf-bogen',
    24: 'aufkleber-etiketten/aufkleber-auf-bogen',
    25: 'aufkleber-etiketten/aufkleber',
    26: 'aufkleber-etiketten/grossaufkleber',
    28: 'kalender/terminkalender-fester-einband',
    29: 'kalender/terminkalender-weicher-einband',
    30: 'kalender/tischkalender',
    32: 'buecher/hardcover-buch',
    33: 'buecher/softcover-buch',
    34: 'textilien',
    35: 'konfektionierung',
}

/**
 * Umgekehrtes Mapping: formsKey → Produkttyp-ID
 */
export const PRODUCT_FORMS_KEY_TO_TYPE_ID = Object.fromEntries(
    Object.entries(PRODUCT_TYPE_ID_TO_FORMS_KEY).map(([id, key]) => [key, Number(id)])
)
